import React from 'react';

import { Image } from '../Image';
import { type ImageProps } from '../Image.types';
import { getCloudinaryUrl } from './getCloudinaryUrl';

// ────────────────────────────────────────────────────────────────────────────────

export const CloudinaryImage = React.memo((props: CloudinaryImageProps) => {
  const { baseUrl, config, ...rest } = props;

  const transformedSource = React.useMemo(() => {
    return getCloudinaryUrl(baseUrl, config);
  }, [baseUrl, config]);

  return (
    <Image
      source={{ uri: transformedSource }}
      accessibilityIgnoresInvertColors
      {...rest}
    />
  );
});

// ─── Types ──────────────────────────────────────────────────────────────────────

type CloudinaryImageProps = Readonly<{
  baseUrl: string;
  config: CloudinaryTransformConfig;
}> &
  Omit<ImageProps, 'source'>;

export type CloudinaryTransformConfig = Parameters<typeof getCloudinaryUrl>[1];
